import { DocumentNode, gql } from "@apollo/client";

export interface StartRenewalWorkflowResponse {
  success: boolean;
}
export class RenewalInfoResponse {
  isLastSignateraOrder: boolean;
  hasRenewal: boolean;
  renewalOrderUidPublic?: string;
  clinicLimsId?: number;
}

export default class OrderRenewalService {
  public static startRenewalWorkflow = (): DocumentNode => gql`
    query StartRenewalWorkflow {
      startRenewalWorkflow {
        success
      }
    }
  `;

  public static getRenewalInfo = (): DocumentNode => gql`
    query GetRenewalInfo($orderUidPublic: String, $token: String) {
      getRenewalInfo(orderUidPublic: $orderUidPublic, token: $token) {
        isLastSignateraOrder
        hasRenewal
        renewalOrderUidPublic
        clinicLimsId
      }
    }
  `;

  public static setPatientInterested = (): DocumentNode => gql`
    mutation SetPatientInterested(
      $isPatientInterested: Boolean!
      $isRenewal: Boolean
    ) {
      setPatientInterested(
        isPatientInterested: $isPatientInterested
        isRenewal: $isRenewal
      ) {
        isPatientInterested
        isRenewal
      }
    }
  `;

  public static setPatientInterestedRenewalNonAuth = (): DocumentNode => gql`
    mutation SetPatientInterestedRenewalNonAuth(
      $token: String!
      $isPatientInterested: Boolean!
    ) {
      setPatientInterestedRenewalNonAuth(
        token: $token
        isPatientInterested: $isPatientInterested
      ) {
        isPatientInterested
        isRenewal
      }
    }
  `;
}
